import React from "react";

/**
 * <StatusPill> — unified status chip. Never render your own uppercase pill.
 * Always pass a `tone` from the closed set — no ad-hoc colors.
 *
 * <StatusPill tone="success">Paid</StatusPill>
 * <StatusPill tone="warning" dot>Pending</StatusPill>
 */
const TONES = {
  neutral: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  info:    "bg-sky-50 text-sky-700 dark:bg-sky-900/30 dark:text-sky-300",
  success: "bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300",
  warning: "bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300",
  danger:  "bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-300",
  brand:   "bg-[#C9A356]/15 text-[#8A6B14] dark:text-[#DDBD77]",
};

const DOTS = {
  neutral: "bg-slate-400",
  info:    "bg-sky-500",
  success: "bg-emerald-500",
  warning: "bg-amber-500",
  danger:  "bg-red-500",
  brand:   "bg-[#C9A356]",
};

export default function StatusPill({
  tone = "neutral",
  children,
  dot = false,
  size = "sm",
  className = "",
  testId,
}) {
  const base = TONES[tone] || TONES.neutral;
  const sz = size === "xs"
    ? "text-[9px] px-1.5 py-0.5"
    : size === "md"
    ? "text-xs px-2.5 py-1"
    : "text-[10px] px-2 py-0.5";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 rounded-full font-bold uppercase tracking-wider whitespace-nowrap ${base} ${sz} ${className}`}
    >
      {dot ? <span className={`w-1.5 h-1.5 rounded-full ${DOTS[tone] || DOTS.neutral}`} /> : null}
      {children}
    </span>
  );
}
